"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ChartTooltip = _interopRequireDefault(require("./ChartTooltip"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class TooltipCompare extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderSingle", () => {
      const _this$props = this.props,
            slice = _this$props.slice,
            metric = _this$props.metric,
            dimension = _this$props.dimension;
      const series = slice.points;
      const s1 = series[0].data || undefined;
      const metricType = s1.metricType,
            x = s1.x,
            y = s1.y,
            datetime = s1.datetime;
      let d;

      if (dimension.startsWith('ga:nth')) {
        d = datetime;
      } else {
        d = x;
      }

      return _react.default.createElement(_ChartTooltip.default, null, _react.default.createElement("h2", {
        className: "admin-tooltip__title"
      }, _react.default.createElement(_.FormatDimension, {
        name: dimension,
        value: d
      })), _react.default.createElement("h3", {
        className: "admin-tooltip__value"
      }, _react.default.createElement(_.FormatMetric, {
        type: metricType,
        value: y
      })));
    });
  }

  render() {
    const _this$props2 = this.props,
          slice = _this$props2.slice,
          metric = _this$props2.metric,
          dimension = _this$props2.dimension;
    const series = slice.points;
    let s1 = series[1].data || undefined;
    let s2 = series[0].data;

    if (s1 && !s2) {
      return this.renderSingle(s2);
    }

    let change, trending;

    if (s1.value > s2.value) {
      change = (s1.value - s2.value) / s1.value * 100;
      trending = "up";
    } else if (s2.value > s1.value) {
      change = (s2.value - s1.value) / s2.value * 100;
      trending = "down";
    } else {
      change = 0;
      trending = "flat";
    }

    if (dimension.startsWith('ga:nth')) {
      s1.d = s1.datetime;
      s2.d = s2.datetime;
    } else {
      s1.d = s1.x;
      s2.d = s2.x;
    }

    return _react.default.createElement(_ChartTooltip.default, null, _react.default.createElement("h2", {
      className: "admin-tooltip__title"
    }, _react.default.createElement(_.FormatDimension, {
      name: dimension,
      value: [s1.d, s2.d]
    })), _react.default.createElement("h3", {
      className: "admin-tooltip__value"
    }, _react.default.createElement(_.FormatMetric, {
      id: s1.metric,
      type: s1.metricType,
      value: s1.y
    })), _react.default.createElement("p", {
      className: "admin-tooltip__change",
      "data-trending": trending
    }, _react.default.createElement(_.FormatMetric, {
      type: "PERCENT",
      value: change
    })));
  }

}

var _default = TooltipCompare;
exports.default = _default;
module.exports = exports.default;